import { Button } from "@mui/material";
import React from "react";
import { useSlidingAppearance } from "../lib/AppearanceContext";
import { slidingAccent } from "../styles/mainStyles";
import TagScrollRow from "./TagScrollRow";

const systemFont =
    '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI", sans-serif';

/**
 * Horizontally scrollable capsule category filter (Screen 5).
 * @param {{ value: string|null, label: string }[]} options
 */
export default function LibraryCategoryPills({ options, value, onChange, snapshotMode = false }) {
    const { tokens, isDark } = useSlidingAppearance();

    return (
        <TagScrollRow sx={{ mb: 2, bgcolor: "transparent", background: "transparent" }}>
            {options.map((opt) => {
                const selected = value === opt.value;
                const tagSlug =
                    snapshotMode && opt.value && typeof opt.value === "string"
                        ? opt.value.trim().toLowerCase()
                        : "";
                return (
                    <Button
                        key={opt.value ?? "__all__"}
                        type="button"
                        id={tagSlug ? `SnapshotSelectTag_${tagSlug}` : undefined}
                        aria-label={tagSlug ? `PUZZLE_SNAPSHOT_TAG_${tagSlug}` : undefined}
                        onClick={() => onChange(opt.value)}
                        sx={{
                            flexShrink: 0,
                            borderRadius: "999px",
                            px: 2,
                            py: 0.75,
                            minHeight: 36,
                            textTransform: "none",
                            fontSize: "0.875rem",
                            fontWeight: 600,
                            fontFamily: systemFont,
                            boxShadow: "none",
                            bgcolor: selected
                                ? slidingAccent
                                : isDark
                                  ? "rgba(255, 255, 255, 0.12)"
                                  : "rgba(255, 255, 255, 0.55)",
                            color: selected ? "#ffffff" : tokens.pillInactiveText,
                            border: selected
                                ? "1px solid transparent"
                                : isDark
                                  ? "1px solid rgba(255,255,255,0.14)"
                                  : "1px solid rgba(44, 58, 74, 0.1)",
                            backdropFilter: selected ? "none" : "blur(6px)",
                            WebkitBackdropFilter: selected ? "none" : "blur(6px)",
                            "&:hover": {
                                bgcolor: selected
                                    ? "#2e7d32"
                                    : isDark
                                      ? "rgba(255, 255, 255, 0.18)"
                                      : "rgba(255, 255, 255, 0.72)",
                                filter: selected ? "none" : "none",
                                boxShadow: "none",
                            },
                        }}
                    >
                        {opt.label}
                    </Button>
                );
            })}
        </TagScrollRow>
    );
}
